import { render, staticRenderFns } from "./StudentWarnTest.vue?vue&type=template&id=2d4f9973&scoped=true"
import script from "./StudentWarnTest.vue?vue&type=script&lang=js"
export * from "./StudentWarnTest.vue?vue&type=script&lang=js"
import style0 from "./StudentWarnTest.vue?vue&type=style&index=0&id=2d4f9973&scoped=true&lang=css"
import style1 from "./StudentWarnTest.vue?vue&type=style&index=1&id=2d4f9973&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4f9973",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d4f9973')) {
      api.createRecord('2d4f9973', component.options)
    } else {
      api.reload('2d4f9973', component.options)
    }
    module.hot.accept("./StudentWarnTest.vue?vue&type=template&id=2d4f9973&scoped=true", function () {
      api.rerender('2d4f9973', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/statistic/StudentWarnTest.vue"
export default component.exports